import { useEffect } from 'react';
import { Typography, Divider } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { getBusinessDetailedView } from '../../../redux/slices/BusinessProfileSlice';
import ProfileSectionLayout from '../../../components/ProfileSectionLayout/ProfileSectionLayout';
import ProfileDetail from '../../../components/Details/ProfileDetail';
import { GLOBAL_CONSTANTS, TITLE_TXT } from '../../../constants/constants';

const { Title } = Typography;

const KYCDetails = () => {
    const { loading, busDetailedViewData } = useSelector((state) => state.profile1);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getBusinessDetailedView());
    }, [dispatch]);

    return (
        <ProfileSectionLayout loading={loading} title={TITLE_TXT.KYC_DETS}>
            <Title level={5}>Company KYC Details</Title>
            <Divider />
            <ProfileDetail
                label={GLOBAL_CONSTANTS.COMP_PAN}
                value={busDetailedViewData?.kycDetails?.kycPanValue?.docValue || 'N/A'}
                isVerified={busDetailedViewData?.kycDetails?.kycPanValue?.isVerified}
            />
            <ProfileDetail
                label={GLOBAL_CONSTANTS.COMP_GSTIN}
                value={busDetailedViewData?.kycDetails?.kycGstinValue?.docValue || 'N/A'}
                isVerified={busDetailedViewData?.kycDetails?.kycGstinValue?.isVerified}
            />

            <Title level={5} style={{ marginTop: '1rem' }}>Director KYC Details</Title>
            <Divider />
            <ProfileDetail
                label={GLOBAL_CONSTANTS.DIR_NAME}
                value={busDetailedViewData?.directorDetails?.directorName || 'N/A'}
                isVerified={busDetailedViewData?.kycDetails?.kycDirectorsPanValue?.isVerified}
            />
            <ProfileDetail
                label={GLOBAL_CONSTANTS.DIR_PAN}
                value={busDetailedViewData?.kycDetails?.kycDirectorsPanValue?.docValue || 'N/A'}
                isVerified={busDetailedViewData?.kycDetails?.kycDirectorsPanValue?.isVerified}
            />
            <ProfileDetail
                label={GLOBAL_CONSTANTS.DIR_AADHAR}
                value={busDetailedViewData?.kycDetails?.kycDirectorsAadhaarValue?.docValue || 'N/A'}
                isVerified={busDetailedViewData?.kycDetails?.kycDirectorsAadhaarValue?.isVerified}
            />
        </ProfileSectionLayout>
    );
};

export default KYCDetails;
